import PropTypes from "prop-types";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  styled,
  tableCellClasses,
} from "@mui/material";
import { TablePaginationActions } from "./table-pagination-actions";

export const CustomTable = ({
  columns,
  rows,
  loading,
  pageInfo,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [10, 25, 100],
  evenOdd = true,
  keyField = "id",
}) => {
  const StyledTableCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#ececec",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(even)": {
      backgroundColor: evenOdd ? theme.palette.action.hover : "white",
    },
  }));

  const getNestedValue = (obj, path) =>
    path.split(".").reduce((acc, part) => acc && acc[part], obj);

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <StyledTableCell
                key={column.field}
                align={column.align}
                style={{ width: column.width }}
              >
                {column.headerName}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell
                colSpan={columns.length}
                align="center"
                sx={{ color: "grey" }}
              >
                Loading...
              </TableCell>
            </TableRow>
          ) : rows.length > 0 ? (
            rows.map((row, rowIndex) => (
              <StyledTableRow key={row[keyField]}>
                {columns.map((column) => (
                  <TableCell
                    key={column.field}
                    align={column.align}
                    size="small"
                  >
                    {column.renderCell
                      ? column.renderCell(row, rowIndex)
                      : getNestedValue(row, column.field)}
                  </TableCell>
                ))}
              </StyledTableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={columns.length} align="center">
                No Data
              </TableCell>
            </TableRow>
          )}
        </TableBody>
        {pageInfo && pageInfo.totalItems > 0 && (
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={rowsPerPageOptions}
                count={pageInfo.totalItems}
                rowsPerPage={pageInfo.size}
                page={pageInfo.currentPage}
                onPageChange={(_, newPage) => onPageChange(newPage)}
                onRowsPerPageChange={(event) =>
                  onRowsPerPageChange(event.target.value)
                }
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        )}
      </Table>
    </TableContainer>
  );
};

CustomTable.propTypes = {
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  pageInfo: PropTypes.object,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  rowsPerPageOptions: PropTypes.array,
  evenOdd: PropTypes.bool,
  keyField: PropTypes.string,
};
